import styles from './index.module.less';
import template from './index.art';
import { EDatePickerType, IOYDatePickerProps, IOYDatePickerState } from "./const";
import OY from '../../types/OY';
import { EEventType } from '../../enums/EEventType';
import { jeact } from '../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYDatePicker extends OY<IOYDatePickerProps, IOYDatePickerState> {
  static displayName = 'OYDatePicker';

  static defaultProps: Partial<IOYDatePickerProps> = {
    pickerType: EDatePickerType.DateRange,
    value: []
  };

  state: IOYDatePickerState = {

  }

  $node = {
    startInput: $(),
    endInput: $()
  };

  timeout: any;

  getDerivedStateFromProps(nextProps: IOYDatePickerProps, state: IOYDatePickerState) {
    return { ...state }
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  componentAfterRender() {
    if (this.props.pickerType === EDatePickerType.DateRange) {
      const dates = this.props.value!.map(va => va ? new Date(Number(va)) : '')
      const dateRange = this.$el.find('.input-daterange')
        .datepicker()
        ;
      dateRange.data('datepicker').pickers.forEach((picker: any, index: number) => {
        picker.update(dates[index]);
      })
      dateRange.on('changeDate', (ev: any) => {
        // 这个函数会触发两次.不知道是不是这个组件的bug~
        // console.log(ev)
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          let startVal: string = this.$node.startInput.val();
          let endVal = this.$node.endInput.val();

          startVal = startVal ? `${new Date(startVal).getTime()}` : '';
          endVal = endVal ? `${new Date(endVal).getTime()}` : '';

          this.$emit(EEventType.onChange, [startVal, endVal])
        })
      })
    }
  }

  setNode() {
    this.$node = {
      startInput: this.$el.find('input[name="start"]'),
      endInput: this.$el.find('input[name="end"]')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OYDatePicker/index.ts